import { render, staticRenderFns } from "./Page-with-right-sidebar.vue?vue&type=template&id=3debfbcb&"
import script from "./Page-with-right-sidebar.vue?vue&type=script&lang=js&"
export * from "./Page-with-right-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports